import Axios from 'axios'
import country from './country'

export function typeOf(obj) {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}

export function deepCopy(data) {
  const t = typeOf(data)
  let o

  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data
  }

  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]))
    }
  } else if (t === 'object') {
    for (let i in data) {
      o[i] = deepCopy(data[i])
    }
  }
  return o
}

export function isWeChatBrowser() {
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.includes('micromessenger')
}

/**
 * 校验是否是移动端设备
 * @returns Boolean
 */
// export function isMobile() {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent)
// }
export function isMobile() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}

/**
 * boolean值处理
 * @param {*} val
 * @returns
 */
export function transforBool(val) {
  if (typeof val === 'boolean') {
    return val
  }
  if (typeof val === 'string' && val === 'true') {
    return true
  }
  return false
}

/**
 * 下载文件
 * @param {*} url
 * @param {*} fileName
 */
export function downloadFile(url, fileName = '', target = '') {
  const a = document.createElement('a')
  if (target) {
    a.setAttribute('target', '_blank')
  }
  a.style.display = 'none'
  fileName && a.setAttribute('download', fileName)
  a.href = url
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * 验证网址是否合法
 * @param {*} url
 * @returns
 */
export function validateWebsite(url) {
  // return /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/.test(
  //   url
  // )
  // return /^(http(s)?:\/\/)(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/.test(
  //   url
  // )
  return /^(http(s)?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/.test(url)
}

/**
 * 获取文件类型
 * @param {*} format
 * @returns
 */
export function getFileFormat(format) {
  format = format.toLowerCase()
  if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
    return 'image'
  }
  if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(format) > -1) {
    return 'vido'
  }
  if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
    return 'audio'
  }
  if (['doc', 'txt', 'docx', 'pages', 'epub'].indexOf(format) > -1) {
    return 'word'
  }
  if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
    return 'excel'
  }
  if (['pdf'].indexOf(format) > -1) {
    return 'pdf'
  }
  if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
    return 'ppt'
  }
  if (
    [
      '7z',
      'rar',
      'zip',
      'apz',
      'ar',
      'bz',
      'car',
      'dar',
      'cpgz',
      'f',
      'ha',
      'hbc',
      'hbc2',
      'hbe',
      'hpk',
      'hyp'
    ].indexOf(format) > -1
  ) {
    return 'zip'
  }
  return 'file'
}

/**
 * 判断是否有其他关键字
 * @param {*} item
 */
export function judgeHaveOther(item) {
  if (typeof item !== 'string') {
    return false
  }
  if (item.match(/^其他($|:)/)) {
    return true
  }
  if (item.match(/^其它($|:)/)) {
    return true
  }
  if (item.match(/^other($|:)/)) {
    return true
  }
}

/**
 * 下载图片
 * @param {*} url
 * @param {*} fileName
 */
export function downloadImg(url, fileName) {
  Axios.get(url, { responseType: 'blob' }).then(res => {
    const downloadUrl = window.URL.createObjectURL(res.data)
    downloadFile(downloadUrl, fileName)
  })
}

export function dealAddressToString(value) {
  if (!Array.isArray(value)) {
    return ''
  }
  let address = ''
  for (let i = 0, len = value.length; i < len; i++) {
    if (i === 4) {
      break
    }
    address += value[i].label + ''
  }
  address += value[4].value
  return address
}

/**
 * 获取URL参数
 * @param {*} url
 * @param {*} key
 * @returns
 */
export function searchQuery(url = window.location.search, key = '') {
  if (!url) {
    return null
  }
  const list = url.split('?')
  if (list.length !== 2) {
    return null
  }
  const query = list[1].split('&')
  if (!query.length) {
    return null
  }
  let search = null
  for (let i = 0, len = query.length; i < len; i++) {
    const item = query[i]
    const temp = item.split('=')
    if (temp.length !== 2) {
      continue
    }
    if (!search) {
      search = {}
    }
    search[temp[0]] = temp[1]
  }
  return key ? search[key] : search
}

/**
 * 根据数组元素获取另一个数组中相同下标的元素
 */
export function getSameIndexValue(arr1, arr2, keys) {
  const index = arr1.findIndex(item => keys.includes(item))
  if (index > -1) {
    return arr2[index]
  }
  return ''
}

/**
 * 获取短语言
 * @param {*} lang
 * @returns
 */
export function getShortLang(lang) {
  switch (lang) {
    case 'zh-CN':
    case 'zh':
      return 'zh'
    case 'zh-HK':
    case 'hk':
      return 'hk'
    case 'en-US':
    case 'en':
      return 'en'
    case 'pt-PT':
    case 'pt':
      return 'pt'
    default:
      return 'zh'
  }
}

/**
 * 获取长语言
 * @param {*} lang
 * @returns
 */
export function getLongLang(lang) {
  switch (lang) {
    case 'zh':
    case 'zh-CN':
      return 'zh-CN'
    case 'hk':
    case 'zh-HK':
      return 'zh-HK'
    case 'en':
    case 'en-US':
      return 'en-US'
    case 'pt':
    case 'pt-PT':
      return 'pt-PT'
    default:
      return 'zh-CN'
  }
}
/**
 * 过滤html标签
 * @param {*} value
 * @param {*} options
 * @returns
 */
export function filterHtmlTag(value, { countSpaces = true, countLineBreaks = true, countPunctuation = true } = {}) {
  if (typeof value !== 'string') {
    return ''
  }
  let text = value.replace(/<[^>]+>/g, '')

  // 2. 解码HTML实体
  text = text.replace(/&nbsp;/g, ' ')
  text = text.replace(/&lt;/g, '<')
  text = text.replace(/&gt;/g, '>')
  text = text.replace(/&amp;/g, '&')
  text = text.replace(/&quot;/g, '"')
  text = text.replace(/&#39;/g, "'")

  // 3. 根据选项处理特殊字符
  if (!countSpaces) {
    text = text.replace(/\s/g, '')
  }
  if (!countLineBreaks) {
    text = text.replace(/[\n\r]/g, '')
  }
  if (!countPunctuation) {
    text = text.replace(/[^\w\s]/g, '')
  }
  return text
}

/**
 * 处理姓名
 * @param {*} info
 * @returns
 */
export function dealName(info) {
  let showName = info.fullName
  if (!showName) {
    if (info.lastName && !info.firstName) {
      showName = info.lastName
    } else if (info.lastName && info.firstName) {
      const char = /^[A-Za-z]+$/.test(info.firstName) ? ' ' : ''
      showName = `${info.lastName}${char}${info.firstName}`
    } else if (!info.lastName && info.firstName) {
      showName = info.firstName
    }
  }
  return showName
}

export function dateFormat(str, fmt) {
  if (!str) {
    return ''
  }
  if (typeof str === 'string') {
    // 后端吐的时间戳可能为Date(111111111)
    // 将中间空格转成T保险
    str = str
      .replace(/^\/Date\((\d+)\)\/$/gi, '$1')
      .replace(/-/g, '/')
      .replace(/T/, ' ')
    if (!isNaN(str)) {
      str = parseInt(str)
    }
  }

  fmt = fmt || 'YYYY-MM-DD hh:mm'

  var date = new Date(str)
  if (isNaN(date.getFullYear())) {
    return ''
  }

  var rules = {
    'M+': date.getMonth() + 1, // 月份
    'D+': date.getDate(), // 日
    'h+': date.getHours(), //  小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
    T: 'T'
  }
  if (/(Y+)/i.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const key in rules) {
    if (new RegExp('(' + key + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? rules[key] : ('00' + rules[key]).substr(('' + rules[key]).length)
      )
    }
  }
  return fmt
}

/**
 * 解析护照信息
 * @param {*} info
 * @returns
 */
export function parsePassportInfo(info, language = 'zh-CN') {
  const obj = {
    birthday: '',
    nationality: '',
    name: '',
    gender: '',
    passportIssueDate: '',
    passportExpireDate: '',
    id: ''
  }
  if (!info) {
    return obj
  }
  const issuingCountry = info.issuingCountry || ''
  const find = country.find(item => item.alpha2 === issuingCountry || item.alpha3 === issuingCountry)
  if (find) {
    obj.nationality = find.value
  }
  obj.id = info.passportID
  obj.name = info.name
  const dealDate = date => {
    const arr = date.split('.')
    if (arr.length === 3 && arr[0].length < arr[2].length) {
      date = `${arr[2]}-${arr[1]}-${arr[0]}`
    } else {
      date = arr.join('-')
    }
    return dateFormat(date, 'YYYY-MM-DD')
  }
  if ('dateOfBirth' in info) {
    obj.birthday = dealDate(info.dateOfBirth)
  }
  if ('dateOfIssuance' in info) {
    obj.passportIssueDate = dealDate(info.dateOfIssuance)
  }
  if ('dateOfExpiration' in info) {
    obj.passportExpireDate = dealDate(info.dateOfExpiration)
  }
  obj.gender = /^f|F|女/.test(info.sex) ? 'b' : 'a'
  return obj
}
